import { useState, useEffect } from 'react';

// Tracks the lg breakpoint (1024px), matching ProductDisplayPage's grid
const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);

  useEffect(() => {
    const mql = window.matchMedia?.('(min-width: 1024px)');
    if (!mql) return;
    const handler = (e: MediaQueryListEvent) => setIsMobile(!e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
};

export default useIsMobile;
